import React, { useState, ReactNode, useEffect } from "react";
import Sidebar from "@components/Sidebar/index";
import { useSelector } from "react-redux";

const DefaultLayout: React.FC<{ children: ReactNode }> = ({ children }) => {
  const isAuthenticated = useSelector((state) => state.auth.status);
  const companyId = useSelector((state) => state.company.companyId);

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const isAuthPage = location.pathname === "/signIn/authenticationChallenge";

  return (
    <div>
      <div className="bg-mayo-bg">
        <div className="flex h-screen overflow-hidden z-0">
          <div className="relative z-50">
            {!isAuthPage && isAuthenticated && (
              <Sidebar
                sidebarOpen={sidebarOpen}
                setSidebarOpen={setSidebarOpen}
                currentPage={location.pathname}
                companyId={companyId}
              />
            )}
          </div>

          <div className="relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden">
            <main>
              <div className="mx-auto max-w-screen-3xl p-4 md:p-6 2xl:p-10">
                {children}
              </div>
            </main>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DefaultLayout;
